module.exports = __webpack_public_path__ + "531d4fa3b4d2f43be551c51911e77b72.jpg";